import Model from "../Model";

class RepresentantsviewsUser extends Model{

    buildUrl ({ param }) {
        return ['visitsbyemployee/getbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new RepresentantsviewsUser;